//import { AllModules, ColDef } from '@ag-grid-enterprise/all-modules';
import { Component, OnInit } from '@angular/core';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";
import { SubHeader } from '../../../../core/models/sub-header.model';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DateService } from '../../../../common/services/date.service';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { AdhocReportsService } from '../../../../admin/services/adhoc-reports-service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { ReportSearchCriteria } from '../../../../admin/models/admin-reports.model';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { tap } from 'rxjs/operators';
import { PermitApplicationSummaryByOwnerReportModel, PermitApplicationTrackingSummaryReportModel } from '../../../../admin/models/adhoc-reports.model';

@Component({
    selector: 'app-permit-applications-tracking-summary-report',
    templateUrl: './permit-applications-tracking-summary-report.component.html',
    styleUrls: ['./permit-applications-tracking-summary-report.component.scss'],
    standalone: false
})
export class PermitApplicationsTrackingSummaryReportComponent implements OnInit {
  reportData: PermitApplicationTrackingSummaryReportModel = new PermitApplicationTrackingSummaryReportModel;
  gridReportData: PermitApplicationSummaryByOwnerReportModel[];
	gridOptions: GridOptions;
	gridApi?: GridApi;
  subHeader: SubHeader = new SubHeader({
      title: "Permitting Applications 1 Report",
      buttons: []
  });
  currentDate: Date = new Date();
  toDate: Date | null;
  fromDate: Date | null;
  subscription: Subscription = new Subscription();
  errorDialog: Dialog = new Dialog("An error has occurred.", [new DialogButton("OK", false, () => { return; })]);

  constructor(private datePipe: DatePipe,
    private readonly dateService: DateService,
    private readonly formatService: GridFormatterService,
    private readonly adhocReportService: AdhocReportsService,
    public subHeaderService: SubHeaderService,
	  public dialogService: DynamicDialogService) {
  }


  ngOnInit() {
    this.subHeaderService.updateSubHeader(this.subHeader);
    this.fromDate = this.dateService.generateDateWithOffset(0, -1, 0);
    this.toDate = this.currentDate;
    let coldefs = this.createColumnDefinitions();
    this.gridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);
    this.gridOptions.headerHeight = 75;
    this.gridOptions.suppressColumnVirtualisation = true;
    this.gridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait ...</span>';
    this.gridOptions.pinnedBottomRowData = this.createData(this.gridReportData);
	  this.gridOptions.onGridReady = (params) => {
		  this.gridApi = params.api;
	  };
    this.generateReport();
  }

  public createData(data: any[]) {
    var result = [];
    if (!data) {
      result.push({
        organizationName: 0,
        applications: 0,
        verticalApplications: 0,
        directionalApplications: 0,
        otherHorizontalApplications: 0,
        nonUrbanApplications: 0,
        urbanApplications: 0,
          definedHorizontalApplications: 0,
          marcellusShaleApplications: 0,
          uticaShaleApplications: 0,
          oilAndGasApplications: 0,
        stratigraphicApplications: 0,
        classIIEnhancedRecoveryApplications: 0,
        classIIDisposalWellBrineApplications: 0,
        classIIISolutionMiningApplications: 0,
        liquidGasStorageApplications: 0,
        gasStorageApplications: 0,
        permitsIssued: 0,
        permitsDenied: 0,
        permitsWithdrawnOrCanceled: 0,
        permitsPending: 0,
        permitsReturned: 0
      });
      return result;
    }
    result.push({
      organizationName: data.length,
      applications: data.reduce((prev, cur) => { return prev + parseInt(cur.applications)}, 0),
      verticalApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.verticalApplications)}, 0),
      directionalApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.directionalApplications)}, 0),
      otherHorizontalApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.otherHorizontalApplications)}, 0),
      nonUrbanApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.nonUrbanApplications)}, 0),
      urbanApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.urbanApplications)}, 0),
        definedHorizontalApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.definedHorizontalApplications) }, 0),
        marcellusShaleApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.marcellusShaleApplications) }, 0),
        uticaShaleApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.uticaShaleApplications) }, 0),
        oilAndGasApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.oilAndGasApplications) }, 0),
        stratigraphicApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.stratigraphicApplications)}, 0),
      classIIEnhancedRecoveryApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.classIIEnhancedRecoveryApplications)}, 0),
      classIIDisposalWellBrineApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.classIIDisposalWellBrineApplications)}, 0),
      classIIISolutionMiningApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.classIIISolutionMiningApplications)}, 0),
      liquidGasStorageApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.liquidGasStorageApplications)}, 0),
      gasStorageApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.gasStorageApplications)}, 0),
      permitsIssued: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsIssued)}, 0),
      permitsDenied: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsDenied)}, 0),
      permitsWithdrawnOrCanceled: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsWithdrawnOrCanceled)}, 0),
      permitsPending: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsPending)}, 0),
      permitsReturned: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsReturned)}, 0)
    });
    return result;
  }

  public createColumnDefinitions() {
    return [
      {
        headerClass: "wrapped",
        headerName: "Owner Name",
        headerTooltip: "Owner Name",
        field: "organizationName",
        tooltipField: "organizationName",
        filter: "agTextColumnFilter",
        filterParams: this.formatService.defaultTextFilterParams,
        minWidth: 200,
        pinned: "left"
      },
      {
        headerClass: "wrapped",
        headerName: "RICS Owner Number",
        headerTooltip: "RICS Owner Number",
        field: "organizationNumber",
        tooltipField: "organizationNumber",
        filter: "agTextColumnFilter",
        filterParams: this.formatService.defaultTextFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "RBDMS Owner Number",
        headerTooltip: "RBDMS Owner Number",
        field: "organizationRBDMSNumber",
        tooltipField: "organizationRBDMSNumber",
        filter: "agTextColumnFilter",
        filterParams: this.formatService.defaultTextFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Applications Received",
        headerTooltip: "Number of Applications Received",
        field: "applications",
        tooltipField: "applications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Issued",
        headerTooltip: "Number of Permits Issued",
        field: "permitsIssued",
        tooltipField: "permitsIssued",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Denied",
        headerTooltip: "Number of Permits Denied",
        field: "permitsDenied",
        tooltipField: "permitsDenied",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Withdrawn or Canceled",
        headerTooltip: "Number of Permits Withdrawn or Canceled",
        field: "permitsWithdrawnOrCanceled",
        tooltipField: "permitsWithdrawnOrCanceled",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Pending",
        headerTooltip: "Number of Permits Pending",
        field: "permitsPending",
        tooltipField: "permitsPending",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Returned For Corrections",
        headerTooltip: "Number of Permits Returned For Corrections",
        field: "permitsReturned",
        tooltipField: "permitsReturned",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Vertical Applications",
        headerTooltip: "Number of Vertical Applications",
        field: "verticalApplications",
        tooltipField: "verticalApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Directional Applications",
        headerTooltip: "Number of Directional Applications",
        field: "directionalApplications",
        tooltipField: "directionalApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Other Horizontal Applications",
        headerTooltip: "Number of Other Horizontal Applications",
        field: "otherHorizontalApplications",
        tooltipField: "otherHorizontalApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Non-Urban Applications",
        headerTooltip: "Number of Non-Urban Applications",
        field: "nonUrbanApplications",
        tooltipField: "nonUrbanApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Urban Applications",
        headerTooltip: "Number of Urban Applications",
        field: "urbanApplications",
        tooltipField: "urbanApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Defined Horizontal Applications",
        headerTooltip: "Number of Defined Horizontal Applications",
        field: "definedHorizontalApplications",
        tooltipField: "definedHorizontalApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
        },
        {
            headerClass: "wrapped",
            headerName: "Number of Marcellus Shale Applications",
            headerTooltip: "Number of Marcellus Shale Applications",
            field: "marcellusShaleApplications",
            tooltipField: "marcellusShaleApplications",
            filter: "agNumberColumnFilter",
            filterParams: this.formatService.defaultNumberFilterParams,
            minWidth: 150
        },
        {
            headerClass: "wrapped",
            headerName: "Number of Utica / Point Pleasant Shale Applications",
            headerTooltip: "Number of Utica / Point Pleasant Shale Applications",
            field: "uticaShaleApplications",
            tooltipField: "uticaShaleApplications",
            filter: "agNumberColumnFilter",
            filterParams: this.formatService.defaultNumberFilterParams,
            minWidth: 150
        },
      {
        headerClass: "wrapped",
        headerName: "Oil & Gas",
        headerTooltip: "Oil & Gas",
        field: "oilAndGasApplications",
        tooltipField: "oilAndGasApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
        },
        {
            headerClass: "wrapped",
            headerName: "Stratigraphic",
            headerTooltip: "Stratigraphic",
            field: "stratigraphicApplications",
            tooltipField: "stratigraphicApplications",
            filter: "agNumberColumnFilter",
            filterParams: this.formatService.defaultNumberFilterParams,
            minWidth: 150
        },
      {
        headerClass: "wrapped",
        headerName: "Class II Enhanced Recovery",
        headerTooltip: "Class II Enhanced Recovery",
        field: "classIIEnhancedRecoveryApplications",
        tooltipField: "classIIEnhancedRecoveryApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Class II Disposal Well \ Brine",
        headerTooltip: "Class II Disposal Well \ Brine",
        field: "classIIDisposalWellBrineApplications",
        tooltipField: "classIIDisposalWellBrineApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Class III Solution Mining",
        headerTooltip: "Class III Solution Mining",
        field: "classIIISolutionMiningApplications",
        tooltipField: "classIIISolutionMiningApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Liquid Gas Storage",
        headerTooltip: "Liquid Gas Storage",
        field: "liquidGasStorageApplications",
        tooltipField: "liquidGasStorageApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      },
      {
        headerClass: "wrapped",
        headerName: "Gas Storage",
        headerTooltip: "Gas Storage",
        field: "gasStorageApplications",
        tooltipField: "gasStorageApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150
      }
    ] as ColDef[];
}

  generateReport() {
    if (this.gridApi) {
      this.gridApi.setGridOption("loading", true);
    }

    const criteria = new ReportSearchCriteria();
      criteria.fromDate = this.fromDate;
      criteria.toDate = this.toDate;

      this.subscription = this.adhocReportService.getPermitApplicationsTrackingSummaryReportData(criteria).pipe(
          tap((data) => {
        this.reportData = data;
        this.gridReportData = data.summeriesByOwner;
      })).subscribe((success) => {
        this.gridApi.setGridOption("rowData", this.gridReportData);
        this.gridApi.setGridOption("pinnedBottomRowData", this.createData(this.gridReportData));
        this.gridApi.setGridOption("loading", false);
        this.gridApi.autoSizeAllColumns();
      }, (fail) => {
        console.error(fail);
        this.gridApi.setGridOption("loading", false);
        this.showError();
    });
  }

  downloadReport() {
    const criteria = new ReportSearchCriteria();
    criteria.fromDate = this.fromDate;
    criteria.toDate = this.toDate;
    let fileName = "PermitApplicationsTrackingSummaryReport";
    if (this.fromDate && this.toDate) {
      const fromDate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
      const toDate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
      fileName = `PermitApplicationsTrackingSummaryReport_${fromDate}_${toDate}`;
    }
    
    const sheetName = "Permit Applications Tracking Summary Report";
    this.formatService.exportDataToExcel(fileName, sheetName, this.gridApi);
  }

  get invalidDateCombination(): boolean {
    let invalid: boolean = false;
    if (this.toDate != null && this.fromDate != null) {
        invalid = this.toDate < this.fromDate;
    }
    return invalid;
  }

  fromDateChanged(model: Date): void {
    this.fromDate = model;
  }

  toDateChanged(model: Date): void {
      this.toDate = model;
  }

  onFilterChanged(params: any): void {
    let rowData = [];
    this.gridApi.forEachNodeAfterFilter(node => {
      rowData.push(node.data);
    });
    this.gridApi.setGridOption("pinnedBottomRowData", this.createData(rowData));
  }

  resizeColumns(): void {
    if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
    }
  }

  showError(): void {
    this.errorDialog.toggleDialog(true);
    this.dialogService.updateDialog(this.errorDialog);
  }

}
